<template>
    <div>   
        <v-container grid-list-xl> 
            <!-- <v-btn color="success" @click="TEST()">DELETE_ALL_SALES</v-btn> -->
            <v-layout align-center="" justify-center="">

                <v-col sm="12" cols="12">
                    <br>
                    <!-- <v-layout>
                        <v-spacer></v-spacer>
                        <mbs-dayshift-selector
                            default_days="1"
                            @apply="APPLY_DAYSHIFTS"
                            />
                    </v-layout>
                    <br>  -->
                    <v-card > 
                        <mbs-page-tab 
                            :items="MY_LINKS"/> 
                             
                        <mbs-item-manager
                            v-model="input_table"
                            :row_click="true"
                            :show_select="false"
                            :row_click_action="true" 
                            :table_tabs="TableTabs"
                            :add_vertical_lines="true"
                            :top_label="false"
                            :filter_date="true"
                            :filter_dayshifts="true"
                            :filter_date_value="'local_created_at'"
                            :filter_default_days="'1'"
                            :filters="FILTERS"
                            :name_items="NAME_ITEMS"
                            :name_item="NAME_ITEM"
                            :value_items="VALUE_ITEMS"
                            :value_item="VALUE_ITEM"
                            :field_items="FIELD_ITEMS"
                            :header_items="HEADER_ITEMS_TELLER" 
                            :data_items="SalesPersonnelData"   
                            :select_items="DataSource"   
                            :is_joined="true"  
                            :path_item="SALES_PATH"   
                            :total_item_values="TOTAL_ITEM_VALUES"   

                            :table_actions="table_actions" 
                            @SELECT_TABLE_ACTION="TABLE_ACTION"
                            @SELECT_ITEM_ACTION="ITEM_ACTION"
                            @apply="APPLY_DAYSHIFTS"
                        />
                    </v-card>
                    <br><br>
                </v-col>  
            </v-layout>
        </v-container>  
        <div>
            <!-- <div v-if="dialog_doc_show"> 
                <mbs-dialog-doc-show
                    v-model="dialog_doc_show" 
                    :title="input_show_doc.title"
                    :data="input_show_doc.data"
                    :data_key="input_show_doc.data_key"
                    :document_type="input_show_doc.document_type"
                    :height="input_show_doc.height"
                    :top_header="input_show_doc.top_header"
                    :bottom_header="input_show_doc.bottom_header"
                />  
            </div> -->
            <div v-if="dialog_sales_transactions">  
                <mbs-sales-transactions
                    v-model="dialog_sales_transactions" 
                    :title="input_show_doc.title"
                    :title_icon="input_show_doc.title_icon"
                    :data="input_show_doc.data" 
                    :table_tabs="input_show_doc.table_tabs" 
                    @SELECT_TABLE_ACTION="SALES_TRANSACTION_TABLE_ACTION"
                    @SELECT_ITEM_ACTION="SALES_TRANSACTION_ITEM_ACTION"
                />  
            </div>
            <div v-if="dialog_orders_transactions">  
                <mbs-orders-transactions
                    v-model="dialog_orders_transactions" 
                    :title="input_show_doc.title"
                    :title_icon="input_show_doc.title_icon"
                    :data="input_show_doc.data" 
                    :table_tabs="input_show_doc.table_tabs" 
                    @SELECT_TABLE_ACTION="ORDERS_TRANSACTION_TABLE_ACTION"
                    @SELECT_ITEM_ACTION="ORDERS_TRANSACTION_ITEM_ACTION"
                />  
            </div>
            
        </div>
    </div> 
</template>

<script>
    import DATA from "../../../../../plugins/DATA"
    let PAGE_NAME = "sales_personnel"    
    import {mapState,mapGetters } from "vuex"
    import { mdiReceiptTextArrowRight } from '@mdi/js';
    export default {
        name:PAGE_NAME, 
        data() {
            return {
                PAGE_LOAD:false,  
                PAGE_CURRENT:1,
                PAGE_SIZE:10,

                NAME_ITEMS:DATA.ITEMS.SALES.names,
                NAME_ITEM:DATA.ITEMS.SALES.name,
                VALUE_ITEMS:DATA.ITEMS.SALE_ORDERS.values,
                VALUE_ITEM:DATA.ITEMS.SALE_ORDERS.value,  

                FIELD_ITEMS:[
                    {type:"number",name:"code",value:"code",label:"Code",required:true,sm:12,md:12}, 
                    {type:"text",name:"name",value:"name",label:"Name",required:true,sm:12,md:12},   
                ],     
                table_actions:[
                    // {type:"action",btn:true,icon:"mdi-refresh",action:"refresh",color:"secondary", outlined:false,  text:"Refresh"},   
                    {type:"action",icon:"mdi-microsoft-excel",action:"export_excel",color:"secondary", outlined:false,  text:"Export to Excel"},  
                ],
                TOTAL_ITEM_VALUES:[ 
                    // {name:'Total Items',value:'total_quantity'}, 
 
                    {name:'Orders No.',value:'orders_number',show_value:'order_number',money:false}, 
                    {name:'Sales No.',value:'sales_number',show_value:'sales_number_',money:false}, 
                    {name:'Total Orders',value:'total_order_price',show_value:'total_order_price_',money:true}, 
                    {name:'Total Sales',value:'total_sold_price',show_value:'total_sold_price_',money:true}, 
                ], 
                input_table:null,
                filter_date:null,
                dialog_doc_show:false,
                dialog_sales_transactions:false,
                dialog_orders_transactions:false,
                dialog_view_receivable:false,
                input_show_doc:{},
                selected_outlet_code:null,
                expected_selected_outlet_code:null,
                IS_FILTERING:false
            }
        },
        created() {
            try {
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
                this.DATA_FILTERING(null,true)
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted() {
            try { 
                this.MBS.actions.header({
                    show:true,
                    type:'subToolbar', 
                    images:null,
                    color:'black',
                    height:"300",
                    opacity:'0.1'
                })
                this.FEEDBACKS(1000) 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME, 
                }) 
            } 
        },
        computed: { 
            route(){
                return this.$route
            },
            vs(){
                return this.$vuetify.breakpoint
            },  
            MY_LINKS(){  
                let thisLinks = this.MBS.actions.FIND_SUB_LINKS("sales",3,true) 
                return thisLinks
            }, 
            SALES_PATH(){  
                let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.sale_orders,true) 
                return path
            }, 
            /////////
             ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                SelectedCompany: state=> state.items['SELECTED_COMPANY'],

            }),
            ...mapState({
                CompanyUsers: state=> state.items[(DATA.ITEMS.COMPANY_USERS.values).toUpperCase()],
                CompanyUserGroups: state=> state.users[(DATA.ITEMS.COMPANY_USER_GROUPS.values).toUpperCase()],
                JoinedCompanyUserGroups: state=> state.join[(DATA.ITEMS.COMPANY_USER_GROUPS.values).toUpperCase()],

                SalesOrders: state=> state.items[(DATA.ITEMS.SALE_ORDERS.values).toUpperCase()],
                JoinedSalesOrders: state=> state.join[(DATA.ITEMS.SALE_ORDERS.values).toUpperCase()],  
                Orders: state=> state.items[(DATA.ITEMS.DAY_ORDERS.values).toUpperCase()],
                JoinedOrders: state=> state.join[(DATA.ITEMS.DAY_ORDERS.values).toUpperCase()], 
                PersonnelSales: state=> state.join[(DATA.ITEMS.PERSONNEL_SALES.values).toUpperCase()], 
                
                Customers: state=> state.items[(DATA.ITEMS.CUSTOMERS.values).toUpperCase()],
                PaymentMethods: state=> state.items[(DATA.ITEMS.PAYMENT_METHODS.values).toUpperCase()],
                JoinedPaymentMethods: state=> state.join[(DATA.ITEMS.PAYMENT_METHODS.values).toUpperCase()],
                DefaultPaymentMethod: state=> state.app[(DATA.ITEMS.DEFAULT_PAYMENT_METHODS.values).toUpperCase()],
                Departments: state=> state.items[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()],
                JoinedDepartments: state=> state.join[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()], 
                Outlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
                JoinedOutlets: state=> state.join[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()], 
                Cashups: state=> state.items[(DATA.ITEMS.CASHUPS.values).toUpperCase()],
                JoinedCashups: state=> state.join[(DATA.ITEMS.CASHUPS.values).toUpperCase()],
                DayShifts: state=> state.items[(DATA.ITEMS.DAYS_SHIFTS.values).toUpperCase()],
                JoinedDayShifts: state=> state.join[(DATA.ITEMS.DAYS_SHIFTS.values).toUpperCase()], 
            }), 
            PaymentMethodsData(){ 
                let DefaultPaymentMethod = this.DefaultPaymentMethod 
                let PaymentMethods = this.PaymentMethods
                let JoinedPaymentMethods = this.JoinedPaymentMethods
                let items = JoinedPaymentMethods?JoinedPaymentMethods:PaymentMethods 
                if(!items){return DefaultPaymentMethod}
                let list = [...DefaultPaymentMethod,...items]  
                return list
            },  
            DepartmentsData(){ 
                let Departments = this.Departments
                let JoinedDepartments = this.JoinedDepartments
                let items = JoinedDepartments?JoinedDepartments:Departments 
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("name",true)) 
                return list
            },  
            SalesOrdersData(){ 
                const SalesOrders = this.SalesOrders
                const JoinedSalesOrders = this.JoinedSalesOrders
                const items = JoinedSalesOrders?JoinedSalesOrders:SalesOrders  
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("local_created_at",false))  
                return list
            }, 
            OrdersData(){ 
                let SalesOrders = this.Orders
                let JoinedSalesOrders = this.JoinedOrders
                let items = JoinedSalesOrders?JoinedSalesOrders:SalesOrders 
                
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("local_created_at",false))  
                return list
            }, 
            OutletsData(){ 
                let Outlets = this.Outlets
                let JoinedOutlets = this.JoinedOutlets
                let items = JoinedOutlets?JoinedOutlets:Outlets 
                return items
            }, 
            DayShiftsData(){ 
                let DayShifts = this.DayShifts
                let JoinedDayShifts = this.JoinedDayShifts
                let items = JoinedDayShifts?JoinedDayShifts:DayShifts  
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("local_created_at",false))   
                return list 
            },  
            CashupsData(){ 
                let Cashups = this.Cashups
                let JoinedCashups = this.JoinedCashups
                let items = JoinedCashups?JoinedCashups:Cashups 
                return items
            }, 
            DayShiftsCashups(){
                let days = this.DayShiftsData
                if(!days){return null}
                let cashups = []
                days.forEach(element => {
                    if (element.joined_cashups) {
                        cashups = [...cashups,...element.joined_cashups]
                    }
                }); 
                if(!cashups){return null} 
                let list = [...cashups]
                list.sort(this.MBS.actions.dynamicSort("local_created_at",false))    
                return list 
            },
            Users(){
                let items  =this.$store.getters.getCompanyUsers
                let list = items?[...items]:null
                if(!list){return null}
                list.sort(this.MBS.actions.dynamicSort('created_at',false))
                return list
            }, 
            JoinedUsers(){
                let users = this.Users
                let join = this.MBS.actions.JOIN_USERS(users)
                return join
            }, 
            SalesPersonnelData(){
                const PersonnelSales = this.PersonnelSales
                const users = this.JoinedUsers
                const sales = this.SalesOrdersData
                const orders = this.OrdersData

                console.log(PersonnelSales,'PersonnelSales...........');
                return PersonnelSales
                
                if(!sales){return null}
                let user_data = []
                sales?.forEach(sale => {
                    const created_uid = sale?.created_uid
                    const updated_uid = sale?.updated_uid
                    const sold_uid = sale?.sold_uid
                    const sales_uid = sold_uid?sold_uid:created_uid?created_uid:updated_uid
                    const is_on_account = sale?.account_type == "on_account"
                    const is_option = sale?.account_type == "payment_option"
                    const is_multiple = sale?.account_type == "multiple"
                    const pay_type = sale?.payment_method_type 

                    const total_sold_price = sale?.total_sold_price 
                     
                    const on_account_number = pay_type=="on_account"?1:0
                    const cash_sales_number = pay_type=="cash"?1:0
                    const other_sales_number = pay_type=="other"?1:0
                    const multiple_sales_number = pay_type=="multiple"?1:0
                    const sales_number = 1 

                    const index = user_data.findIndex(item=>item.sales_uid == sales_uid)
                   
                    if (index == -1) {
                        let teller = users?.find(user=>user.uid == sales_uid)
                        let teller_name = teller?teller.surname+' '+teller.names:'--' 
                        let user = teller?{...teller}:{}
                        user_data.push({
                            ...user,
                            sales_uid,
                            teller,teller_name,
                           
                            on_account_number,
                            cash_sales_number,
                            other_sales_number,
                            multiple_sales_number,

                            //
                            deleted_number:0,
                            paid_number:0,
                            unpaid_number:0,  
                            orders_number:0, 
                            total_order_price:0,
                            //

                            sales_number,
                            orders_number:0, 
                            total_sold_price,
                            total_sold_price_:this.MBS.actions.money(total_sold_price),
                            sales_transaction:
                            "[C="+cash_sales_number+
                            "] [O="+other_sales_number+
                            "] [M="+multiple_sales_number+
                            "] [A="+on_account_number+
                            "] Total="+sales_number,
                            orders_transaction:"P="+" U="+" D"+" T=",
                        })
                    }else{
                        user_data[index].on_account_number = user_data[index].on_account_number+on_account_number 
                        user_data[index].cash_sales_number = user_data[index].cash_sales_number+cash_sales_number 
                        user_data[index].other_sales_number = user_data[index].other_sales_number+other_sales_number 
                        user_data[index].multiple_sales_number = user_data[index].multiple_sales_number+multiple_sales_number 
                         
                        user_data[index].sales_number = user_data[index].sales_number+sales_number,  
                        user_data[index].total_sold_price = user_data[index].total_sold_price+total_sold_price
                        user_data[index].total_sold_price_ =this.MBS.actions.money( user_data[index].total_sold_price)
                        user_data[index].sales_transaction=
                        "[C="+user_data[index].cash_sales_number+
                        "] [O="+user_data[index].other_sales_number+
                        "] [M="+user_data[index].multiple_sales_number+
                        "] [A="+user_data[index].on_account_number+
                        "] Total="+user_data[index].sales_number
                        
                    } 
                });

                orders?.forEach(order => {
                    const created_uid = order?.created_uid
                    const updated_uid = order?.updated_uid
                    const sold_uid = order?.sold_uid
                    const waiter = order?.waiter
                    const waiter_uid = waiter?.uid
                    const sales_uid = waiter_uid?waiter_uid:sold_uid?sold_uid:created_uid?created_uid:updated_uid 
                    const deleted = order?.deleted 
                    const sold = order?.deleting_reason == "sold"  

                    const total_order_price = order?.total_sold_price 
                     
                    const deleted_number = deleted && !sold?1:0 
                    const paid_number = deleted && sold?1:0 
                    const unpaid_number = sold?0:1 
                    const orders_number = 1 
                    
                    const index = user_data.findIndex(item=>item.sales_uid == sales_uid)
                   
                    if (index == -1) {
                        let teller = users?.find(user=>user.uid == sales_uid)
                        let teller_name = teller?teller.surname+' '+teller.names:'--' 
                        let user = teller?{...teller}:{}
                        user_data.push({
                            ...user,
                            sales_uid,
                            teller,teller_name,
                           
                            deleted_number,
                            paid_number,
                            unpaid_number,  
                            orders_number, 
                            total_order_price,

                            total_sold_price_:this.MBS.actions.money(total_order_price),
                            orders_transaction:
                                "[P="+paid_number+ 
                                "] [U="+unpaid_number+
                                "] [D="+deleted_number+
                                "] Total="+orders_number, 
                        })
                    }else{
                        user_data[index].deleted_number = user_data[index].deleted_number+deleted_number 
                        user_data[index].paid_number = user_data[index].paid_number+paid_number 
                        user_data[index].unpaid_number = user_data[index].unpaid_number+unpaid_number 
                        user_data[index].orders_number = user_data[index].orders_number+orders_number 
                           
                        user_data[index].total_order_price = user_data[index].total_order_price+total_order_price
                        user_data[index].total_order_price_ =this.MBS.actions.money( user_data[index].total_order_price)
                        user_data[index].orders_transaction= 
                            "[P="+user_data[index].paid_number+
                            "] [U="+user_data[index].unpaid_number+
                            "] [D="+user_data[index].deleted_number+
                            "] Total="+user_data[index].orders_number
                        
                    } 
                });
  
                return user_data
            },
            DataSource(){ 
                let Customers = this.Customers
                let PaymentMethodsData = this.PaymentMethodsData
                let Departments = this.DepartmentsData
                let Outlets = this.OutletsData
                let DayShifts = this.DayShiftsData
                let Cashups = this.DayShiftsCashups
                let SalesOrders = this.SalesOrdersData
                let Tellers = this.JoinedUsers 
                return { 
                    Customers:Customers,
                    PaymentMethods:PaymentMethodsData,
                    Departments:Departments,
                    Outlets:Outlets,
                    DayShifts:DayShifts,
                    Cashups:Cashups,
                    SalesOrders:SalesOrders,
                    Tellers:Tellers,
                }
            },
            TableTabs(){ 
                const outlets =  this.OutletsData
                const sales =  this.SalesOrders
                const orders =  this.Orders
                const number = outlet=>{
                    const ss = outlet?sales?.filter(sale=>sale.outlet_code==outlet.code):sales
                    const oo = outlet?orders?.filter(sale=>sale.outlet_code==outlet.code):orders
                    return this.MBS.actions.SIZE(oo)+"|"+this.MBS.actions.SIZE(ss)
                }
                let tabs = [
                    {
                        name:"All",
                        show_if:(this_,item)=>{ 
                            return true
                        },
                        indicator:{
                            color:'primary',
                            value: number()
                        }
                    },    
                ]
                if (outlets) {
                    outlets.forEach(outlet => {
                        tabs.push({
                            ...outlet,
                            name:outlet.name,
                            show_if:(this_,item)=>{
                                const outlet_code = item.outlet_code  
                                return true
                            },
                            indicator:{
                                color:'primary',
                                value:number(outlet)
                            }
                        })
                    });
                }
                return tabs
            },
            TabsOrders(){ 
                return [
                    {
                        name:"Unpaid Orders",
                        show_if:(this_,item)=>{
                            const deleted = item.deleted
                            const deleting_reason = item.deleting_reason !="sold"
                            return !deleted 
                        },
                        indicator:{
                            color:'primary',
                            value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}
                        }}
                    },
                    {name:"Paid order",show_if:(this_,item)=>{
                        const deleted = item.deleted
                        const deleting_reason = item.deleting_reason =="sold"
                        return deleted && deleting_reason
                    },
                    indicator:{
                            color:'primary',
                            value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}
                        }}
                    },
                        {name:"Deleted order",show_if:(this_,item)=>{
                            const deleted = item.deleted
                            const deleting_reason = item.deleting_reason !="sold"
                            return deleted && deleting_reason
                        },
                        indicator:{
                                color:'primary',
                                value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}
                            }}
                    }, 
                ]
            },
            TabsSales(){ 
                return [
                    {
                        name:"All",
                        show_if:(this_,item)=>{ 
                            return true
                        },
                        indicator:{
                            color:'primary',
                            value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}
                        }}
                    },{
                        name:"Cash",show_if:(this_,item)=>{
                             const payment_option_key = item.payment_option_key
                            const payment_method_name = item.payment_method_name
                            const isCash = payment_method_name == "Cash"
                            const cash = payment_option_key == "cash"

                            return cash || isCash
                             
                        },
                        indicator:{
                            color:'primary',
                            value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}
                        }}
                    },{
                        name:"Others",show_if:(this_,item)=>{
                            const account_type = item.account_type
                            const payment_option_key = item.payment_option_key
                            const isNotCash = payment_option_key != "cash"
                            const isOption = account_type == "payment_option"

                            return isOption && isNotCash
                        },
                        indicator:{
                            color:'primary',
                            value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}
                        }}
                    },{
                        name:"Multiple",show_if:(this_,item)=>{
                            const account_type = item.account_type
                            const payment_method_name = item.payment_method_name
                            const multiple = account_type == "multiple"
                            const isMultiple = payment_method_name?.indexOf(",") != -1
                            return isMultiple
                        },
                        indicator:{
                            color:'primary',
                            value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}
                        }}
                    },{
                        name:"On Account",show_if:(this_,item)=>{
                            const account_type = item.account_type
                            const on_account = account_type == "on_account"
                            return on_account
                        },
                        indicator:{
                            color:'primary',
                            value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}
                        }}
                    },
                     
                ]
            },
            
            FILTERS(){ 
                return [ 
                    // {
                    //     type:"autocomplete",value:"department_code",prepend_inner_icon:'mdi-format-list-group',clearable:true,filled:false,multiple:true
                    //     ,chips:true,deletable_chips:true,label:"Department",
                    //     select:{
                    //         name:'Departments',
                    //         value:'code',
                    //         text:'name'
                    //     }, 
                    //     required:false,sm:12,md:12,step_name:"Name"
                    // },

                    {
                        type:"autocomplete",value:"payment_method_name",prepend_inner_icon:'mdi-account-cash',clearable:true,filled:false,multiple:true,
                        chips:true,deletable_chips:true,label:"Payment",
                        select:{
                            name:'PaymentMethods',
                            value:'name',
                            text:'name'
                        }, 
                        required:false,sm:12,md:6,step_name:"Name"
                    },   
                    {
                        type:"autocomplete",value:"receipt_number",barcode:true,prepend_inner_icon:'mdi-barcode',clearable:true,filled:false,multiple:true,
                        chips:true,deletable_chips:true,label:"Receipt Number",
                        select:{
                            name:'SalesOrders',
                            value:'receipt_number',
                            text:'receipt_number'
                        }, 
                        required:false,sm:12,md:6,step_name:"Name"
                    }, 
                    {
                        type:"autocomplete",value:"created_uid",barcode:false,prepend_inner_icon:'mdi-tag-text',clearable:true,filled:false,
                        multiple:true,chips:true,deletable_chips:true,label:"Teller Name",
                        select:{
                            name:'Tellers',
                            value:'uid',
                            text:'name'
                        }, 
                        required:false,sm:12,md:6,step_name:"Name"
                    }, 
                    {
                        type:"autocomplete",value:"customer_key",barcode:false,prepend_inner_icon:'mdi-tag-text',clearable:true,filled:false,
                        multiple:true,chips:true,deletable_chips:true,label:"Customer",
                        select:{
                            name:'Customers',
                            value:'key',
                            text:'name'
                        }, 
                        required:false,sm:12,md:6,step_name:"Name"
                    }, 
                    {
                        type:"autocomplete",value:"cashup_key",barcode:true,prepend_inner_icon:'mdi-account-cash-outline',clearable:true,filled:false,multiple:true,
                        chips:true,deletable_chips:true,label:"Cashup",
                        select:{
                            name:'Cashups',
                            value:'key',
                            text:'operating_date_'
                        }, 
                        search:{
                            filter:(item, queryText, itemText) => { 
                                let index = (a,b)=>{
                                    if(!a||!b){return false}
                                    a = ""+a; b = ""+b
                                    return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                                } 
                                let first = index(itemText,queryText)
                                let second = item?index(item.code,queryText):false
                                if(!item){return first} 
                                return first || second 
                            },
                            item_icon:{
                                name:'mdi-account-cash-outline',
                                tile:true
                            },
                            item_title:['till_name'],
                            item_subtitle:['teller_name','key','local_created_at_']
                        },
                        required:false,sm:12,md:6,step_name:"Name"
                    },   
                    {
                        type:"autocomplete",value:"day_shift_key",barcode:true,prepend_inner_icon:'mdi-network-pos',clearable:true,filled:false,multiple:true,
                        chips:true,deletable_chips:true,label:"Day Shift",
                        select:{
                            name:'DayShifts',
                            value:'key',
                            text:'operating_date_'
                        }, 
                        search:{
                            filter:(item, queryText, itemText) => { 
                                let index = (a,b)=>{
                                    if(!a||!b){return false}
                                    a = ""+a; b = ""+b
                                    return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                                } 
                                let first = index(itemText,queryText)
                                let second = item?index(item.code,queryText):false
                                if(!item){return first} 
                                return first || second 
                            },
                            item_icon:{
                                name:'mdi-network-pos',
                                tile:true
                            },
                            item_title:['outlet_name'],
                            item_subtitle:['teller_name','operating_date_']
                        },
                        required:false,sm:12,md:6,step_name:"Name"
                    }, 
                    {
                        type:"autocomplete",value:"outlet_code",barcode:true,prepend_inner_icon:'mdi-sitemap',clearable:true,filled:false,multiple:true,
                        chips:true,deletable_chips:true,label:"Outlet",
                        select:{
                            name:'Outlets',
                            value:'code',
                            text:'name'
                        }, 
                        required:false,sm:12,md:12,step_name:"Name"
                    },    
                ]
            }, 
            HEADER_ITEMS_TELLER(){ 
                 
                let headers = [
                    {id:1,name:"General",title:true},
                    {id:0,name:"image",show:true},
                    {id:0,name:"No.",value:'no',show:false},  
                    {id:0,name:"name",value:'name',show:true}, 
                    {id:0,name:"surname",value:'surname',show:false}, 
                    {id:0,name:"names",value:'names',show:false}, 
                    {id:0,name:"Phone",value:'phone_number',show:false},   
                    {id:0,name:"Designation",value:'designation_name',show:true},      
                    {id:0,name:"User Group",value:'company_user_group_name',show:false},      
                    {id:0,name:"Card",value:'card_code',show:false},      
                    {id:0,name:"O. Transaction",value:'orders_transaction',align:'right',show:true},      
                    {id:0,name:"S. Transaction",value:'sales_transaction',align:'right',show:true},      
                    {id:0,name:"T. Orders",value:'total_order_price_',align:'right',show:true},      
                    {id:0,name:"T. Sales",value:'total_sold_price_',align:'right',show:true},      
                    {id:0,name:"T. Balance",value:'balance_number',align:'right',show:false},      
                    {id:0,name:"on",value:'online',show:false},   
                    {id:0,name:"logged",value:'logged',show:false},   
                    {id:0,name:"status",value:'active_status',show:false},   
                    {id:0,name:"create",value:'created_at_',show:false},   
                    {id:0,name:"update",value:'updated_at_',show:false}, 
                    {id:0,name:"user",show:false}, 
                    {id:0,name:"action",align:"center",show:true,item:[  
                        {name:"Sales Transactions",action:"sales_transactions",icon:"mdi-tag-check"},
                        {name:"Orders Transaction",action:"orders_transactions",icon:"mdi-cart"},
                        {name:"View Receivables",action:"view_receivables",icon:"mdi-clipboard-text-clock"},
                    ]}, 
                ] 
                return headers 
            },  
            HEADER_ITEMS(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"",value:'icon_image',color:"primary",size:40,tile:true,show:false},
                    {id:0,name:"Number",value:'no',show:false},   
                    {id:0,name:"Date",value:'local_created_at_',show:true},   
                    {id:0,name:"Payment",value:"payment_method_name",show:true},  
                    {id:0,name:"Day Shift Code",value:'day_shift_key',show:false},   
                    {id:0,name:"Cashup Code",value:'cashup_key',show:false},      
                    {id:0,name:"Receipt No.",value:"receipt_number",align:"center",show:true},         
                    {id:0,name:"Outlet",value:"outlet_name",show:false},         
                    {id:0,name:"Teller",value:"teller_name",show:true},         
                    {id:0,name:"Till",value:"till_name",show:false},         
                    {id:0,name:"Customer",value:'customer_name',show:true},   
                    {id:0,name:"Payment",value:"payment_method",show:false},     
                    {id:0,name:"Items",value:'total_quantity_',align:'right',show:true},   
                    {id:0,name:"Cost Price",value:'total_cost_price_',align:'right',show:false},   
                    {id:0,name:"Discount",value:'all_discounts_',align:'right',show:true},   
                    // {id:0,name:"Sold Price",value:'total_sold_price_',align:'right',show:true},   
                    {id:0,name:"Price",value:'total_sold_price_',align:'right',show:true},    
                    {id:0,name:"Sold Price(+)",value:'sum_amount_',align:'right',show:true}, 
                    {id:0,name:"Tax A",value:'taxable_a_',align:'right',show:false},   
                    {id:0,name:"Tax B",value:'taxable_b_',align:'right',show:false},   
                    {id:0,name:"Tax E",value:'taxable_c_',align:'right',show:false},   
                    {id:0,name:"VAT",value:'total_vat_',align:'right',show:false},   
                    {id:0,name:"Given Amount",value:'given_amount_',align:'right',show:false},   
                    {id:0,name:"update",value:'updated_at',show:false},   
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"View Sales Report",action:"view_order",icon:"mdi-eye"}, 
                        {name:"Sales Report Page",action:"view_order_page",icon:mdiReceiptTextArrowRight}, 
                        {name:"Archive Sales Report",action:"archive_item",icon:"mdi-delete"},   
                        // {name:"log",action:"log",icon:"mdi-plus"},   
                    ]}, 
                ]
            }, 
               
        },
        methods: { 
            TEST(){
                this.$store.dispatch("join_personnelSales").then(res=>{
                    console.log(res,'//////////*****');
                    
                }).catch(err=>{
                    console.log(err,"++++++++--------"); 
                })
            },
            async DELETE_ALL_SALES(){
                try {
                    let items = this.SalesOrdersData
                    let size = this.MBS.actions.SIZE(items)
                    let progress = 0

                      
                    if(!items){
                    } 

                    // return
                    this.MBS.actions.progressDialog({
                        show:true,
                        text:"Deleting ("+size+"/"+progress+") ..."
                    })

                    // let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.,true)
                    // let path = "/MPOS/COMPANY_DATA/all-supplieers/ACCOUNTS/DAYS_SHIFT_SALES"
                    // let path = "/MPOS/COMPANY_DATA/mangochi-sun-supermarket/ACCOUNTS/DAYS_SHIFT_SALES/"
                    let path = "/MPOS/COMPANY_DATA/vybe-cafe-&-bistro/ACCOUNTS/DAYS_SHIFT_SALES/"

                    
                    let delete_items = []
                    for (const item of items) {
                        // let res = await this.$store.dispatch('fi_delete',{
                        //     action:DATA.ITEMS.ITEMS.values+"__", 
                        //     path:path+item.day_shift_key+'/'+item.key, 
                        // }) 
                        progress = progress+1
                        this.MBS.actions.progressDialog({ 
                            show:true,
                            text:"Deleting ("+size+"/"+progress+") ..."
                        })
                        delete_items.push({
                            path:path+item.day_shift_key+'/'+item.key,
                            key:item.key,
                            day_shift_key:item.day_shift_key,
                        })
                        console.log(path+item.day_shift_key+'/'+item.key,'path:, ....');
                        
                    }
                    console.log(delete_items,'delete_items------i--');

                    this.$store.dispatch('fi_delete',{
                        action:"day_shifts",
                        data:delete_items,
                        multiple:true
                    }).then(res=>{
                        console.log(res,'res.......i....');
                    }).catch(error=>{
                        console.log(error,'error-----------i..');
                    })
                    this.MBS.actions.progressDialog()
                } catch (error) {
                    console.log(error,'ee,,,,,,,,');
                }

            },
            TABLE_ACTION(action,item){
                try { 
                    if (action == "refresh") {
                        let mbs_text = this.MBS.text.item_action("Sales Transactions","Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo,
                            action:{
                                code:PAGE_NAME+"=RELOAD-ITEMS", 
                            } 
                        })
                    }else if (action == "received_stock") { 
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control/receive-stock",true))
                    }else if (action == "return_stock") { 
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control/return-stock",true))
                    }else if (action == "transfer_stock") { 
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control/transfer-stock",true))
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            ITEM_ACTION(action,item){
                try { 
                    let link = "/stock/stock-control/"+(item?item.key:null)
                    const path = this.MBS.actions.COMPANY_LINK(link,true)  

                   
                    if (action == "view_order_page") {
                        let receipt_key = item?item.key:null
                        this.MBS.actions.go("/sales-receipt/"+receipt_key) 
                    }else if (action == "sales_transactions") {  
                        const sales = this.SalesOrdersData
                        const tell_sales = sales?.filter(sale=>{
                            const created_uid = sale?.created_uid
                            const updated_uid = sale?.updated_uid
                            const sold_uid = sale?.sold_uid
                            const waiter = sale?.waiter
                            const waiter_uid = waiter?.uid
                            const sales_uid = waiter_uid?waiter_uid:sold_uid?sold_uid:created_uid?created_uid:updated_uid
                            return sales_uid == item.uid
                        })
                        this.input_show_doc = {}
                        this.input_show_doc.data = tell_sales
                        this.input_show_doc.table_tabs = this.TabsSales
                        this.input_show_doc.title_icon = "mdi-tag-check"
                        this.input_show_doc.title = this.MBS.actions.TEXT_UP(item?.name)+" [ SALE(S) ]"
                        this.dialog_sales_transactions = true
                        setTimeout(() => {
                            this.MBS.events.$emit("ON_VIEW_SALES_TRANSACTIONS",{
                                data:tell_sales
                            }) 
                        }, 100);
                         
                    }else if (action == "orders_transactions") {   
                        const orders = this.OrdersData
                        const tell_sales = orders?.filter(order=>{
                            const created_uid = order?.created_uid
                            const updated_uid = order?.updated_uid
                            const sold_uid = order?.sold_uid
                            const waiter = order?.waiter
                            const waiter_uid = waiter?.uid
                            const sales_uid =waiter_uid?waiter_uid:sold_uid?sold_uid:created_uid?created_uid:updated_uid
                            return sales_uid == item.uid
                        })
                        this.input_show_doc = {}
                        this.input_show_doc.data = tell_sales
                        this.input_show_doc.table_tabs = this.TabsOrders
                        this.input_show_doc.title_icon = "mdi-cart"
                        this.input_show_doc.title = this.MBS.actions.TEXT_UP(item?.name)+" [ ORDER(S) ]"
                        this.dialog_orders_transactions = true
                        setTimeout(() => {
                            this.MBS.events.$emit("ON_VIEW_ORDERS_TRANSACTIONS",{
                                data:tell_sales
                            }) 
                        }, 100);
                         
                    }else if (action == "on_row_clicked") {  
                    } 
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ITEM_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            
            SALES_TRANSACTION_TABLE_ACTION(action,item){
                try { 
                    if (action == "refresh") {
                         
                    }else if (action == "close") { 
                        this.dialog_sales_transactions = false
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SALES_TRANSACTION_TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            SALES_TRANSACTION_ITEM_ACTION(action,item){
                try { 
                     
                    if (action == "view_order_page") {
                        let receipt_key = item?item.key:null
                        this.MBS.actions.go("/sales-receipt/"+receipt_key) 
                    } else if (action == "on_row_clicked") {  
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SALES_TRANSACTION_ITEM_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            ORDERS_TRANSACTION_TABLE_ACTION(action,item){
                try { 
                    if (action == "refresh") {
                         
                    }else if (action == "close") { 
                        this.dialog_orders_transactions = false
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ORDERS_TRANSACTION_TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            ORDERS_TRANSACTION_ITEM_ACTION(action,item){
                try { 
                     
                    if (action == "view_order_page") {
                        let receipt_key = item?item.key:null
                        this.MBS.actions.go("/sales-receipt/"+receipt_key) 
                    } else if (action == "on_row_clicked") {  
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ORDERS_TRANSACTION_ITEM_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },


            RELOAD_ITEMS(){
                try {
                    let company = this.SelectedCompany
                    let company_key = company?company.company_key:null
                    this.MBS.actions.progressDialog({
                        show:true,
                        text:"Refresh..."
                    })
                    this.$store.dispatch('fi_get_item',{
                        name:DATA.ITEMS.DAYS_SHIFTS_SALES.values,
                        on:false, 
                        cash:true, 
                        get:false, 
                        company_key:company_key, 
                    }).then(res=>{ 
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_success("Sales Transactions","Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    }).catch(error=>{
                        console.log(error,'error.......');
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_fail("Sales Transactions","Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    })
                } catch (error) {
                    
                }

            },
            DATA_FILTERING(outlet_code,force){
                try { 
                    if (outlet_code!=this.selected_outlet_code || force) {
                        if (!this.IS_FILTERING) {
                            this.IS_FILTERING = true
                            setTimeout(() => { 
                                this.$store.dispatch("join_personnelSales",{outlet_code})
                                .then(res=>{ 
                                    this.selected_outlet_code=outlet_code
                                    this.IS_FILTERING = false
                                    if (outlet_code != this.expected_selected_outlet_code) {
                                        this.DATA_FILTERING(this.expected_selected_outlet_code)
                                        console.log(this.expected_selected_outlet_code,'this.this.expected_selected_outlet_code');
                                        
                                    }
                                }).catch(err=>{
                                    console.log(err,"++++++++--------"); 
                                    this.IS_FILTERING = false
                                })
                            }, 100); 
                        }else{
                            this.expected_selected_outlet_code = outlet_code
                        } 
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DATA_FILTERING',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            APPLY_DAYSHIFTS(data){
                try {
                    console.log(data,'APPLY_DAYSHIFTS........');
                    const dayshifts_keys = data?.dayshifts_keys
                    const selected_dayshifts_keys = data?.selected_dayshifts_keys
                    const search_keys = this.MBS.actions.SIZE(selected_dayshifts_keys)?
                        selected_dayshifts_keys:dayshifts_keys
                     
                    console.log(search_keys,'search_keys.....');
                    
                    let company = this.SelectedCompany
                    let company_key = company?company.company_key:null
                    this.MBS.actions.progressDialog({
                        show:true,
                        text:"Loading Sales..."
                    })
                    this.$store.dispatch('http_get_item',{
                        name:DATA.ITEMS.DAYS_SHIFTS_SALES.values,
                        company_key:company_key,
                        path:"getDayShiftsSales", 
                        data: {
                            company_key:company_key,
                            day_shifts_keys:search_keys
                        }
                    }).then(res=>{ 
                        this.MBS.actions.progressDialog({
                            show:true,
                            text:"Loading Orders..."
                        })
                        return this.$store.dispatch('http_get_item',{
                            name:DATA.ITEMS.DAY_ORDERS.values,
                            company_key:company_key,
                            path:"getDayShiftsOrders", 
                            data: {
                                company_key:company_key,
                                day_shifts_keys:search_keys
                            }
                        })
                    }).then(res=>{ 
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_success("Transactions","Loading")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        }) 
                    }).catch(error=>{
                        console.log(error,'error.......');
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_fail("Transactions","Loading")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    })
                } catch (error) {
                    
                }

            },
            SHOW_DIALOG_DOCUMENT(payload){
                try {
                    let data = {}
                    let doc_type = payload?.doc_type
                    let doc_title = payload?.doc_title
                    if(payload?.data){
                        data = payload?.data
                    }
                    if(payload?.key){
                        data.key = payload?.key
                    }
                    if(!this.input_show_doc){
                        this.input_show_doc = {}
                    } 
                    if(data=={}){return null}
                    if (doc_type) {
                        console.log(doc_type,'doc_type/.................');
                    }

                    this.input_show_doc.data = {...data,merge_doc_type:"receipt"}
                    this.input_show_doc.data_key = data.key
                    this.input_show_doc.title = doc_title
                    this.input_show_doc.document_type = doc_type?doc_type:"invoice"
                    this.dialog_doc_show = true  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SHOW_DIALOG_DOCUMENT',
                        page:PAGE_NAME, 
                    }) 
                }

            },
             
            //---------------[MAIN FUNCTIONS]------------ 
            DIALOG_YES(action){ 
                try {
                    if (action.code) {
                        if (action.code ===PAGE_NAME+'=ADD-ITEM') {
                            if (action.YES) {
                                if (this.input.check) { 
                                    this.input.check = false 
                                    setTimeout(() => {
                                        this.input.loading = true 
                                        this.$store.dispatch("fi_add",{
                                            action:this.VALUE_ITEM,
                                            path:this.PATH_ITEM,
                                            data:action.data,
                                            us:this.us
                                        })
                                    }, ACTION_TIME);  
                                }   
                            } else {
                                
                            }
                        } 
                        if (action.code ===PAGE_NAME+'=RELOAD-ITEMS') {
                            if (action.YES) {
                                this.RELOAD_ITEMS()
                            } else {
                                
                            }
                        }   
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },  
            FEEDBACKS(time){ 
                try {
                    if (!time) { time=400 }
                    setTimeout(()=>{
                        let us = this.loggedUser 
                        let ps = this.processes
                        let ld = this.loading
                        let res = this.responses

                        //Check process 
                        if (ps) {
                            let gettingItems = ps.find(process=>{
                                return process.name == 'getting/'+this.VALUE_ITEMS
                            })
                            
                             
                             
                        }else{
                            this.PAGE_LOAD =true
                        } 
                    },time)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FEEDBACKS',
                        page:PAGE_NAME, 
                    })  
                } 
            },
            PAGE_PERMISSION(){
                try {
                    let us
                    if (!us) {
                        this.MBS.actions.go("/")
                    }  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'PAGE_PERMISSION',
                        page:PAGE_NAME, 
                    })
                }
            },
    
        },
        watch: { 
            us(v){
                this.PAGE_PERMISSION()
            },
            loading(value){
                this.FEEDBACKS(1)
            },
            processes(value){
                this.FEEDBACKS(1)
            },
            responses(value){
                this.FEEDBACKS(1) 
            },
            input_table(value){
                const current_table_tab = value?.current_table_tab
                const tabs = this.TableTabs
                const tab = tabs?.[current_table_tab]
                const outlet_code = tab?.code
                this.DATA_FILTERING(outlet_code)
                
            }
        },
    }
</script>
 
